export const base = {
  created: function () {
    this.$root.$on("change-language", this.onChangeLanguage)
    this.languages = this.$root.$_languages
    this.selectedLanguage = this.$root.$_selectedLanguage
  },
  beforeDestroy() {
    this.$root.$off('change-language', this.onChangeLanguage)
  },
  data: function () {
    return {
      selectedLanguage: null,
      languages: [],
      version: 0
    }
  },
  computed: {
    title: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.title, this.selectedLanguage, this.version)
    },
    text: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.text, this.selectedLanguage, this.version)
    }
  },
  methods: {
    getTextFromMultiLang(field, lang) {
      console.log("getTextFromMultiLang", field, lang)
      if (!field) {
        return ''
      } else if (typeof field === 'string') {
        return field
      } else {
        return field[lang]
      }
    },
    changeLanguage(lang) {
      this.$root.$emit("change-language", lang)
    },
    onChangeLanguage(data) {
      console.log("change language", data)
      this.selectedLanguage = data
    },
    /* forceUpdate is here for the preview Tag in order to kick off an update of the visuals */
    forceUpdate() {
      // inc version that will kick of computed
      this.version = this.version + 1
    }
  }
}

export const titleAndText = {
  computed: {
    title: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.title, this.selectedLanguage, this.version)
    },
    text: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.text, this.selectedLanguage, this.version)
    }
  }
}

export const linkLabel = {
  computed: {
    linkLabel: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.linkLabel, this.selectedLanguage, this.version)
    }
  }
}

export const hasImagesOnly = {
  computed: {
    hasImagesOnly: function () {
      for (let i = 0; i < this.options.length; i++) {
        let a = this.options[i]
        console.log('hasImagesOnly', a[a.lang])
        let text = (a.text || '')[(a.text || '').lang]
        if (text && text.trim().length > 0) {
          return false
        }
      }
      return true
    }
  }
}

export const URL = {
  computed: {
    URL: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.URL, this.selectedLanguage, this.version)
    }
  }
}

export const eyecatcher = {
  computed: {
    eyecatcher: function () {
      return this.getTextFromMultiLang(this.meta.eyecatcher, this.selectedLanguage, this.version)
    }
  }
}

export const quiz = {
  computed: {
    question: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.quiz.question, this.selectedLanguage, this.version)
    },
    instruction: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.quiz.instruction, this.selectedLanguage, this.version)
    },
    correctFeedback: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.quiz.correctFeedback, this.selectedLanguage, this.version)
    },
    wrongFeedback: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.quiz.wrongFeedback, this.selectedLanguage, this.version)
    },
    submitButtonText: function () {
      // version to kick off update from forceUpdate
      return this.getTextFromMultiLang(this.meta.quiz.submitButtonText, this.selectedLanguage, this.version)
    }
  }
}

export const singleChoice = {
  computed: {
    question: function () {
      return this.getTextFromMultiLang(this.meta.singleChoice.question, this.selectedLanguage, this.version)
    }
  }
}

export const coverURL = {
  computed: {
    coverURL: function () {
      return this.getTextFromMultiLang(this.tag.meta.URL, this.selectedLanguage, this.version)
    }
  }
}
